module.exports = __webpack_public_path__ + "static/media/tag_weixian.59a97bbb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/asset/image/product/tag_weixian.svg
// module id = 760
// module chunks = 0